
import { computed, defineComponent, PropType, Ref, ref } from 'vue'

import NewCheckbox from '@/common/new-components/NewCheckbox/index.vue'

import { useOnOutsidePress } from 'vue-composable'

type Column = {
    key: string
    name: string
}

/**
 * Компонент для управления отображением колонок
 * Props.columnsParent - изначальная константа колонок
 * Props.value - реактивный массив колонок
 */

export default defineComponent({
    components: {
        NewCheckbox,
    },
    props: {
        columnsParent: {
            type: Array as PropType<Column[]>,
            default: () => [],
        },
        value: {
            type: Array as PropType<Column[]>,
            default: () => [],
        },
    },
    emits: ['update:value', 'outside-click'],
    setup(props, { emit }) {
        const elementref: Ref<HTMLElement | null> = ref(null)

        const isColumnChecked = (column_key: string) => {
            return valueKeys.value.includes(column_key)
        }

        const toggleColumn = (column: Column) => {
            const valueCopy = [...props.value]

            if (isColumnChecked(column.key)) {
                const index = props.value.findIndex((valColumn) => valColumn.key === column.key)
                valueCopy.splice(index, 1)
                emit('update:value', valueCopy)
            } else {
                const index = props.columnsParent.findIndex(
                    (parColumn) => parColumn.key === column.key
                )

                if (index >= 0) {
                    valueCopy.splice(index, 0, { ...column })
                    emit('update:value', valueCopy)
                }
            }
        }

        const toggleAllColumns = () => {
            if (allColumnsChecked.value) {
                emit('update:value', [])
            } else {
                emit('update:value', [...props.columnsParent])
            }
        }

        const onOutsideClick = () => {
            emit('outside-click')
        }

        useOnOutsidePress(elementref, onOutsideClick)

        const valueKeys = computed(() => props.value.map((column) => column.key))
        const allColumnsChecked = computed(() =>
            props.columnsParent.every((parentCol) => valueKeys.value.includes(parentCol.key))
        )

        return {
            elementref,
            isColumnChecked,
            toggleColumn,
            allColumnsChecked,
            toggleAllColumns,
        }
    },
})
